import { isMenuQrTable } from './menuTableRules'

const CART_DISABLED_TABLES: Record<string, string[]> = {
  rkeeper2: ['1'],
  'bar-dpo-gastrobar-7289': ['113']
}

export const isCartDisabledForTable = (restaurantCode: string, tableId?: string | null) => {
  if (isMenuQrTable(restaurantCode, tableId)) {
    return true
  }
  if (!restaurantCode || !tableId) {
    return false
  }
  const tables = CART_DISABLED_TABLES[restaurantCode]
  return Boolean(tables && tables.includes(String(tableId)))
}
